// extracted by mini-css-extract-plugin
export default {"languageSwitchTrigger":"LanguageSwitch_languageSwitchTrigger__Qe4X9"};